import React from 'react';
import { User, Phone, MapPin, Building } from 'lucide-react';

const CourseInfoSection = ({ studentData, editableData, isEditing, onInputChange }) => {
    const editableFields = ['studentRequirement'];

    return (
     
            <div className="info-grid">
                <div className="info-item">
                    <label>Course</label>
                    <span>{studentData.course}</span>
                </div>
                
                {/* <div className="info-item">
                    <label>Course Type</label>
                    <span>{studentData.courseType}</span>
                </div> */}
                
                {/* <div className="info-item">
                    <label>Student Requirement</label>
                    {isEditing && editableFields.includes('studentRequirement') ? (
                        <input
                            type="text"
                            value={editableData.studentRequirement || ''}
                            onChange={(e) => onInputChange('studentRequirement', e.target.value)}
                        />
                    ) : (
                        <span>{studentData.studentRequirement}</span>
                    )}
                </div> */}
                
                <div className="info-item">
                    <label>Staff Assigned</label>
                    <span>{studentData.staffAssigned}</span>
                </div>
                
                <div className="info-item">
                    <label>Mentor</label>
                    <span><User size={16} /> {studentData.courseDetails?.mentor || studentData.mentor || 'Not assigned'}</span>
                </div>
                
                <div className="info-item">
                    <label>Mentor Contact</label>
                    <span><Phone size={16} /> {studentData.courseDetails?.mentorNumber || studentData.mentorNumber || 'Not available'}</span>
                </div>
                
                <div className="info-item">
                    <label>Location</label>
                    <span><MapPin size={16} /> {studentData.adminlocation}</span>
                </div>
                
                <div className="info-item">
                    <label>Branch</label>
                    <span><Building size={16} /> {studentData.adminbranch}</span>
                </div>
            </div>
    );
};

export default CourseInfoSection;